export const SkeletonCard = () => (
  <div className="bg-slate-50 rounded-2xl overflow-hidden border border-slate-100">
    <div className="skeleton" style={{ paddingTop: "68%" }} />
    <div className="p-4 space-y-2">
      <div className="skeleton h-3 w-1/2 rounded" />
      <div className="skeleton h-4 w-full rounded" />
      <div className="skeleton h-3 w-3/4 rounded" />
      <div className="flex justify-between mt-3">
        <div className="skeleton h-6 w-16 rounded" />
        <div className="skeleton h-7 w-16 rounded-lg" />
      </div>
    </div>
  </div>
);
